import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import InputScanBin from './InputScanBin';
import PropTypes from 'prop-types';

export default function InputScanBinPanel({
  binObjIn,
  outputData,
  displayFilter = false
}) {
  const [binObj, setBinObj] = useState(binObjIn);
  const [filterCode, setFilterCode] = useState('');

  useEffect(() => {
    setBinObj(binObjIn);
  }, [binObjIn]);

  const handleOutputData = data => {
    outputData({
      ...data,
      filterCode: filterCode || ''
    });
    setBinObj(data);
  };

  const handleFilterChange = e => {
    setFilterCode(e.target.value);
  };

  const handleFilterBlur = () => {
    outputData({
      ...binObj,
      filterCode: filterCode || ''
    });
  };

  const isBinValid = !!binObj?.binBarcode;

  return (
    <>
      <Row>
        <Col md={5}>
          <Card className="mb-3">
            <Card.Body>
              <Card.Title style={{ paddingBottom: '10px' }}>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Scan Bin</Form.Label>
                      <InputScanBin
                        binBarcode={binObj?.binBarcode}
                        outputData={handleOutputData}
                        disabled={!isBinValid}
                      />
                    </Form.Group>
                  </Col>
                  {displayFilter && (
                    <Col xs={6}>
                      <Form.Group>
                        <Form.Label>Filter Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter code..."
                          value={filterCode}
                          onChange={handleFilterChange}
                          onBlur={handleFilterBlur}
                          disabled={!isBinValid}
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </Card.Title>

              <div>
                <Row>
                  <Col xs={6}>
                    <Form.Group style={{ marginLeft: '7px' }}>
                      <Form.Label>
                        Bin No: {binObj?.binBarcode || '-'}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group style={{ marginLeft: '7px' }}>
                      <Form.Label>
                        Location: {binObj?.location || '-'}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

InputScanBinPanel.propTypes = {
  outputData: PropTypes.func,
  binObjIn: PropTypes.object,
  displayFilter: PropTypes.bool,
};
